<template>
  <FormShell
    :title="$t('title')"
    show-back-btn
    :next-btn-text="$t('nextBtn')"
    :subtext="$t('subtext')"
  >
    <template #body>
      <PriceRangeDwellingTypeFormStep :progress-value="progressValue" />
    </template>
  </FormShell>
</template>

<script>
import AbstractFormPage from 'chimera/all/components/page/AbstractFormPage'
import FormShell from '~/components/form/FormShell.PD-10913'
import PriceRangeDwellingTypeFormStep from '~/components/form/steps/priceRangeDwellingType/PriceRangeDwellingTypeFormStep.PD-10913'
import VariantGuard from '~/middleware/VariantGuard.PD-10913'

export default {
  components: {
    FormShell,
    PriceRangeDwellingTypeFormStep,
  },

  extends: AbstractFormPage,

  layout: 'variant.PD-10913',

  middleware: [VariantGuard], // PD-10913: shadows FlowGuard.

  /**
   * @returns {object}
   */
  data() {
    return {
      path: '/v2/offertes-aanvragen/prijsklasse-woning',
      progressValue: 53,
      checkoutStep: 3,
    }
  },

  /**
   * Set translated head meta from i18n.
   */
  created() {
    this.headTitle = this.$t('headTitle')
    this.headDescription = this.$t('headDescription')
  },
}
</script>

<i18n>
{
  "nl-NL": {
    "headTitle": "Prijsklasse woning",
    "headDescription": "Geef aan om welke prijsklasse en wat voor type woning het gaat waarmee de makelaar je kan helpen.",
    "title": "Prijsklasse",
    "nextBtn": "Volgende",
    "subtext": "Gratis & volledig vrijblijvend"
  }
}
</i18n>
